
import { Metamodel } from '../base/model';
import { IModel } from '../base/annotation';

import { OracleServiceCloudLinkedService } from 'app/model/linkedservice/oracle-service-cloud.linkedservice';
import { TabularTypeDataset } from './tabular-type.dataset';
import { format } from 'app/shared/utils/string.util';

@Metamodel.model({
    name: 'OracleServiceCloudObject',
    display: [
        format(stringResources.ModelName_DatasetTemplate, stringResources.OracleServiceCloud_DisplayText),
        format(stringResources.ModelName_DatasetsTemplate, stringResources.OracleServiceCloud_DisplayText)
    ],
    constraints: {
        linkedService: {
            model: OracleServiceCloudLinkedService.MODEL // Linked service redefined
        }
    }
})
export class OracleServiceCloudObjectDataset extends TabularTypeDataset {
    public static readonly MODEL: IModel;

    public constructor(name?: string, description?: string) {
        super(name, description);
    }
}
